import { useSelector } from 'react-redux'

import { useErpTaxRates } from '../../../hooks/useErpTaxRates'
import SelectInput from '../SelectInput'

const VATSelect = (props) => {
  const company = useSelector((state) => state.company.company)

  const defaultTaxRateOptions = [
    { label: '17%', value: '17%' },
    { label: '0%', value: '0%' },
  ]

  const { taxRates } = useErpTaxRates(company)

  const taxRateOptions =
    company.taxId && taxRates?.length
      ? taxRates?.map((item) => ({ label: item?.name, value: item?.name }))
      : defaultTaxRateOptions

  return <SelectInput options={taxRateOptions || []} {...props} />
}

export default VATSelect
